import { render } from "./AppointmentDetail.vue?vue&type=template&id=7e47df9c&ts=true"
import script from "./AppointmentDetail.vue?vue&type=script&lang=ts"
export * from "./AppointmentDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__